import { BooleanNumber } from '../model/BooleanNumber';
import { Nullable } from './../model/Nullable';
import { HttpClient } from './HttpClient';

interface CardOrganizations {
  id: number;
  name: string;
  date: string;
  updated_at: string;
  active: number;
  type_id: number;
  type_name: string;
}

interface CardStructures {
  data: CardOrganizations[];
}

interface CardResponse {
  card_number: string;
  first_name: string;
  is_valid: boolean;
  last_name: string;
  qr: string;
  second_name: Nullable<string>;
  status: BooleanNumber;
  structures: CardStructures,
  membership_active_to?: string | null;
  membership_active_from?: string | null;
}

export class CardApi {
  static async data(userId: string): Promise<CardResponse> {
    const { data } = await HttpClient.getInstance().get<CardResponse>(
      `/card/${userId}`,
    );

    return data;
  }

  static async pdf(): Promise<Blob> {
    const { data } = await HttpClient.getInstance().get<Blob>('/pdf', {
      responseType: 'blob',
    });

    return data;
  }
}
